import { Component, OnInit, ViewChild } from '@angular/core';
import { ActingProfileSearchRequest } from '../../../../models/net/request/acting-profile-search-request';
import { SearchComponent } from '../../../base/search/search.component';
import { ActingProfileSearchResult } from '../../../../models/net/result/acting-profile-search-result';
import { AppService } from '../../../../services/app.service';
import { ActingProfileService } from '../../../../services/acting-profiles/acting-profile.service';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-acting-profiles',
    templateUrl: './acting-profiles.component.html',
    styleUrls: ['./acting-profiles.component.css', '../../../../app.component.css']
})

export class ActingProfilesComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "FirstName", "LastName", "ProfileName", "Delete"];
    public override searchRequest: ActingProfileSearchRequest = new ActingProfileSearchRequest();
    public override searchResult: ActingProfileSearchResult[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.ActingProfileSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: ActingProfileService) {

        super(appService, sessionService, itemService, "actingprofile", "ActingProfile");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.ActingProfileSearchRequest;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: ActingProfileSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: ActingProfileSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: ActingProfileSearchResult) => i.ActingProfileId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: ActingProfileSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
